import { useState, useEffect, ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import api from '../../axiosInstance'
import { useTranslation } from 'react-i18next';
import { PageTitleBar } from '../../components/layout/PageBar';
import { APIRequestGet, APIRequestPost } from '../../utils/APIRequests';
import {
    AstraAdminSubscriptionCountData,
    AstraAdminSubscriptionCountSchema,
    AstraAdminSubscriptionDataList,
    AstraAdminSubscriptionListSchema
} from './api/AstraAdminSubscription';

const AdminSubscription = (): ReactNode => {
    const { t } = useTranslation(['nav_menu']);
    const [subscriptions, setSubscriptions] = useState<AstraAdminSubscriptionDataList>([]);
    const [createCodeEmail, setCreateCodeEmail] = useState<string>("");
    const [subscriptionCount, setSubscriptionCount] = useState<AstraAdminSubscriptionCountData>();
    const [prolongationDays, setProlongationDays] = useState<number>(20);
    const [generateDaysFile, setGenerateDaysFile] = useState(31);
    const [generateCountFile, setGenerateCountFile] = useState(50);
    // Мутирующие вызовы: повторный клик создаёт дубли, поэтому кнопки блокируются на время запроса.
    const [isCreatingCode, setIsCreatingCode] = useState(false);
    const [isProlongation, setIsProlongation] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    useEffect(() => {
        APIRequestGet(`/astraAdminSubscription/getByTimeCreate?count=50&page=0`, {
            schema: AstraAdminSubscriptionListSchema
        }).then(response => {
            console.log(response.data);
            setSubscriptions(response.data);
        });

        APIRequestGet(`/astraAdminSubscription/getSubscriptionCount`, {
            schema: AstraAdminSubscriptionCountSchema
        }).then(response => {
            setSubscriptionCount(response.data);
        });
    }, []);

    function createCode() {
        setIsCreatingCode(true);
        APIRequestPost(`/astraAdminSubscription/createCode`, {
            data: { email: createCodeEmail }
        }).then(() => {
            window.location.reload();
        }).finally(() => setIsCreatingCode(false));
    }

    function prolongation() {
        // Пустое поле даёт parseInt("") === NaN, а в теле запроса NaN превращается в null.
        // Ноль и отрицательные значения тоже недопустимы: это массовая перезапись
        // TimeDeactivation по всем подпискам.
        if (!Number.isFinite(prolongationDays) || prolongationDays <= 0) {
            return;
        }

        setIsProlongation(true);
        APIRequestPost(`/astraAdminSubscription/prolongationAll`, {
            data: { days: prolongationDays }
        }).finally(() => setIsProlongation(false));
    }

    function downloadLog(dayCount: number, codeCount: number) {
        // TODO: add blob download to APIRequest
        setIsDownloading(true);
        api({
            url: '/astraAdminSubscription/downloadCodes',
            method: 'POST',
            data: { dayCount, codeCount },
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "activation_keys.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).finally(() => setIsDownloading(false));
    }

    return (
        <>
            <PageTitleBar title={t('admin_subscriptions')} />
            <div className='max-width text-page-padding'>
                <p>Subscription count: {subscriptionCount?.all} Active: {subscriptionCount?.active}</p>
                <table className='table table-striped' aria-labelledby="tableLabel" style={{ tableLayout: "fixed" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}>Email</th>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "10%" }}></th>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "30%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="key">
                            <td><Form.Control type="email" defaultValue={createCodeEmail} onChange={(event) => { setCreateCodeEmail(event.target.value) }} /></td>
                            <td></td>
                            <td style={{ fontSize: "15px" }}></td>
                            <td></td>
                            <td><button style={{ width: "100%" }} className="btn btn-danger" disabled={isCreatingCode || createCodeEmail.trim() === ""} onClick={() => { createCode(); }}>Create code</button></td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}>-</th>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "10%" }}></th>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "30%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="key">
                            <td>Продлить на это кол-во дней:</td>
                            <td><Form.Control type="number" defaultValue={prolongationDays} onChange={(event) => { setProlongationDays(parseInt(event.target.value)) }} /></td>
                            <td style={{ fontSize: "15px" }}></td>
                            <td>Продлится только тем у кого меньше дней!</td>
                            <td><button style={{ width: "100%" }} className="btn btn-danger" disabled={isProlongation || !Number.isFinite(prolongationDays) || prolongationDays <= 0} onClick={() => { prolongation(); }}>Prolongation</button></td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}>-</th>
                            <th style={{ width: "20%" }}></th>
                            <th style={{ width: "10%" }}></th>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "30%" }}></th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}>Количество дней</th>
                            <th style={{ width: "20%" }}>Количество подписок</th>
                            <th style={{ width: "10%" }}></th>
                            <th style={{ width: "30%" }}></th>
                            <th style={{ width: "30%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="key">
                            <td><Form.Control type="number" defaultValue={generateDaysFile} onChange={(event) => { setGenerateDaysFile(parseInt(event.target.value)) }} /></td>
                            <td><Form.Control type="number" defaultValue={generateCountFile} onChange={(event) => { setGenerateCountFile(parseInt(event.target.value)) }} /></td>
                            <td style={{ fontSize: "15px" }}></td>
                            <td></td>
                            <td><button style={{ width: "100%" }} className="btn btn-danger" disabled={isDownloading} onClick={() => { downloadLog(generateDaysFile, generateCountFile); }}>Generate File</button></td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th style={{ width: "30%" }}>Email</th>
                            <th style={{ width: "20%" }}>Code</th>
                            <th style={{ width: "10%" }}>Is active</th>
                            <th style={{ width: "30%" }}>Time create</th>
                            <th style={{ width: "30%" }}>Time deactivation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(subscriptions) && subscriptions.map(i =>
                            <tr key={i.modemId}>
                                <td>{i.email}</td>
                                <td>{i.code}</td>
                                <td>{i.isActive ? "Active" : ""}</td>
                                <td>{i.timeCreate}</td>
                                {i.isRotten ? <td style={{ color: "red" }}>{i.timeDeactivation}</td> : <td>{i.timeDeactivation}</td>}
                                {/*<td><Link to={`/statistics/modem?imei=${i.imei}`}>{i.imei}</Link></td>*/}
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default AdminSubscription;